﻿/* 
Object:         Occupancy (bezetting)
Description:    Logic and events for the module Occupancy (Bezetting)
Used in:        Occupancy
*/

window.occupancy = function () {
    var occupancyHours = {};
    var availablePeople = {};

    /**
    * Refresh vehicles from group
    * @param {number} groupId
    */
    function loadVehicles(groupId) {
        if (groupId != undefined) {

            var data = { groupId: groupId };
            communication.syncJSON("GET", appsettings.getUrl("Occupancy/GetVehicles"), data, function (responseData) {
                // Listbox
                var lb = $("#LVehicles").data("kendoListBox");
                lb.dataSource.data(responseData);
            });
        }
    }

    /**
    * Refresh no occupancy summary with new data
    * @param {string} newData
    */
    function refreshNoOccupancySummary(newData) {
        if (newData != null) {
            // Listbox            
            var lb = $("#LBNoOccupancyDays").data("kendoListBox");
            lb.dataSource.data(newData);
        }
    }

    /**
    * Refresh total occupancy
    * @param {Object} jsonData
    */
    function refreshTotalsOccupancy(jsonData) {
        //Table or List?
        var htmlData = "<table style='width: 100%'>";

        if (jsonData === null) return;

        for (let i = 0; i < jsonData.length; i++) {
            let totalOccupancy = jsonData[i];

            // int OrderBy
            // int ServiceFunctionID
            // string Label
            // int Available { get; set; }
            // int Necessary { get; set; }
            // int Configured { get; set; }
            // bool Occupancy { get; set; }

            let { OrderBy, ServiceFunctionID, Label, Available, Necessary, Configured, Occupancy } = jsonData[i];
            htmlData += "<tr>";
            htmlData += "<td><span>" + Label + "</span></td>";
            htmlData += "<td class='countertableHeader' data-id='" + ServiceFunctionID + "'>";
            if (Occupancy === 'True') {
                htmlData += "<span class='countertableHeader-red'>";
            }
            else {
                htmlData += "<span class='countertableHeader'>";
            }

            htmlData += Available + "/" + Necessary + "/" + Configured + "</span></td>";
            htmlData += "</tr>";
        }

        htmlData += "</table>";

        $("#TTotals").html(htmlData);
    }

    /**
    * refresh detail occupancy
    * @param {string} htmlData
    */
    function refreshDetailsOccupancy(htmlData) {
        //Panel
        $('#POccupancy').html(htmlData);
    }

    /**
    * refresh available people
    * @param {string} jsonData
    */
    function refreshAvailablePeople(jsonData) {

        //Array
        availablePeople = {};

        if (jsonData === null) return;

        for (let s = 0; s < jsonData.length; s++) {
            //let serviceFunctionDataItem = jsonData[i];

            // ServiceFunctionDataItem
            // int ServiceFunctionID
            // string CounterData                

            let { ServiceFunctionID, DateOfDay, DayCounters } = jsonData[s];

            var dayData = availablePeople[ServiceFunctionID];
            if (dayData == null) {
                dayData = {};
            }
            for (let q = 0; q < DayCounters.length; q++) {
                let { K, V } = DayCounters[q];

                dayData['Q' + DateOfDay + K] = V;
            }
            availablePeople[ServiceFunctionID] = dayData;
        }
    }

    /**
    * refresh occupancy hours
    * @param {string} jsonData
    */
    function refreshOccupancyHours(jsonData) {
        //Array
        occupancyHours = {};

        if (jsonData === null) return;

        for (let s = 0; s < jsonData.length; s++) {
            //let serviceFunctionDataItem = jsonData[i];

            // ServiceFunctionDataItem
            // int ServiceFunctionID
            // string CounterData                

            let { ServiceFunctionID, DateOfDay, DayCounters } = jsonData[s];

            var dayData = occupancyHours[ServiceFunctionID];
            if (dayData == null) {
                dayData = {};
            }
            for (let q = 0; q < DayCounters.length; q++) {
                let { K, V } = DayCounters[q];

                dayData['Q' + DateOfDay + K] = V;
            }
            occupancyHours[ServiceFunctionID] = dayData;
        }
    }


    /**
    * AddHoverCurrentHour
    */
    function addHoverFunctions() {
        
        //LSFunctionID = e.getAttribute('data-storage-id');
        //$(this).closest('div').attr('data-storage-id')

        $('.stripes li:nth-child(1)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 0, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 0, 0) });
        $('.stripes li:nth-child(2)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 0, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 0, 15) });
        $('.stripes li:nth-child(3)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 0, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 0, 30) });
        $('.stripes li:nth-child(4)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 0, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 0, 45) });
        $('.stripes li:nth-child(5)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 1, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 1, 0) });
        $('.stripes li:nth-child(6)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 1, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 1, 15) });
        $('.stripes li:nth-child(7)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 1, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 1, 30) });
        $('.stripes li:nth-child(8)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 1, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 1, 45) });
        $('.stripes li:nth-child(9)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 2, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 2, 0) });
        $('.stripes li:nth-child(10)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 2, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 2, 15) });
        $('.stripes li:nth-child(11)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 2, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 2, 30) });
        $('.stripes li:nth-child(12)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 2, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 2, 45) });
        $('.stripes li:nth-child(13)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 3, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 3, 0) });
        $('.stripes li:nth-child(14)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 3, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 3, 15) });
        $('.stripes li:nth-child(15)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 3, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 3, 30) });
        $('.stripes li:nth-child(16)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 3, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 3, 45) });
        $('.stripes li:nth-child(17)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 4, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 4, 0) });
        $('.stripes li:nth-child(18)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 4, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 4, 15) });
        $('.stripes li:nth-child(19)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 4, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 4, 30) });
        $('.stripes li:nth-child(20)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 4, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 4, 45) });
        $('.stripes li:nth-child(21)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 5, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 5, 0) });
        $('.stripes li:nth-child(22)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 5, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 5, 15) });
        $('.stripes li:nth-child(23)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 5, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 5, 30) });
        $('.stripes li:nth-child(24)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 5, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 5, 45) });
        $('.stripes li:nth-child(25)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 6, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 6, 0) });
        $('.stripes li:nth-child(26)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 6, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 6, 15) });
        $('.stripes li:nth-child(27)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 6, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 6, 30) });
        $('.stripes li:nth-child(28)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 6, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 6, 45) });
        $('.stripes li:nth-child(29)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 7, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 7, 0) });
        $('.stripes li:nth-child(30)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 7, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 7, 15) });
        $('.stripes li:nth-child(31)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 7, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 7, 30) });
        $('.stripes li:nth-child(32)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 7, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 7, 45) });
        $('.stripes li:nth-child(33)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 8, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 8, 0) });
        $('.stripes li:nth-child(34)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 8, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 8, 15) });
        $('.stripes li:nth-child(35)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 8, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 8, 30) });
        $('.stripes li:nth-child(36)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 8, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 8, 45) });
        $('.stripes li:nth-child(37)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 9, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 9, 0) });
        $('.stripes li:nth-child(38)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 9, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 9, 15) });
        $('.stripes li:nth-child(39)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 9, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 9, 30) });
        $('.stripes li:nth-child(40)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 9, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 9, 45) });
        $('.stripes li:nth-child(41)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 10, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 10, 0) });
        $('.stripes li:nth-child(42)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 10, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 10, 15) });
        $('.stripes li:nth-child(43)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 10, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 10, 30) });
        $('.stripes li:nth-child(44)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 10, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 10, 45) });
        $('.stripes li:nth-child(45)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 11, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 11, 0) });
        $('.stripes li:nth-child(46)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 11, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 11, 15) });
        $('.stripes li:nth-child(47)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 11, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 11, 30) });
        $('.stripes li:nth-child(48)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 11, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 11, 45) });
        $('.stripes li:nth-child(49)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 12, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 12, 0) });
        $('.stripes li:nth-child(50)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 12, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 12, 15) });
        $('.stripes li:nth-child(51)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 12, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 12, 30) });
        $('.stripes li:nth-child(52)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 12, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 12, 45) });
        $('.stripes li:nth-child(53)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 13, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 13, 0) });
        $('.stripes li:nth-child(54)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 13, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 13, 15) });
        $('.stripes li:nth-child(55)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 13, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 13, 30) });
        $('.stripes li:nth-child(56)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 13, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 13, 45) });
        $('.stripes li:nth-child(57)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 14, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 14, 0) });
        $('.stripes li:nth-child(58)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 14, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 14, 15) });
        $('.stripes li:nth-child(59)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 14, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 14, 30) });
        $('.stripes li:nth-child(60)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 14, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 14, 45) });
        $('.stripes li:nth-child(61)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 15, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 15, 0) });
        $('.stripes li:nth-child(62)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 15, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 15, 15) });
        $('.stripes li:nth-child(63)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 15, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 15, 30) });
        $('.stripes li:nth-child(64)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 15, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 15, 45) });
        $('.stripes li:nth-child(65)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 16, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 16, 0) });
        $('.stripes li:nth-child(66)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 16, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 16, 15) });
        $('.stripes li:nth-child(67)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 16, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 16, 30) });
        $('.stripes li:nth-child(68)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 16, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 16, 45) });
        $('.stripes li:nth-child(69)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 17, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 17, 0) });
        $('.stripes li:nth-child(70)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 17, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 17, 15) });
        $('.stripes li:nth-child(71)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 17, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 17, 30) });
        $('.stripes li:nth-child(72)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 17, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 17, 45) });
        $('.stripes li:nth-child(73)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 18, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 18, 0) });
        $('.stripes li:nth-child(74)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 18, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 18, 15) });
        $('.stripes li:nth-child(75)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 18, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 18, 30) });
        $('.stripes li:nth-child(76)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 18, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 18, 45) });
        $('.stripes li:nth-child(77)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 19, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 19, 0) });
        $('.stripes li:nth-child(78)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 19, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 19, 15) });
        $('.stripes li:nth-child(79)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 19, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 19, 30) });
        $('.stripes li:nth-child(80)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 19, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 19, 45) });
        $('.stripes li:nth-child(81)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 20, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 20, 0) });
        $('.stripes li:nth-child(82)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 20, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 20, 15) });
        $('.stripes li:nth-child(83)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 20, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 20, 30) });
        $('.stripes li:nth-child(84)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 20, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 20, 45) });
        $('.stripes li:nth-child(85)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 21, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 21, 0) });
        $('.stripes li:nth-child(86)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 21, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 21, 15) });
        $('.stripes li:nth-child(87)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 21, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 21, 30) });
        $('.stripes li:nth-child(88)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 21, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 21, 45) });
        $('.stripes li:nth-child(89)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 22, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 22, 0) });
        $('.stripes li:nth-child(90)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 22, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 22, 15) });
        $('.stripes li:nth-child(91)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 22, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 22, 30) });
        $('.stripes li:nth-child(92)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 22, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 22, 45) });
        $('.stripes li:nth-child(93)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 23, 0); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 23, 0) });
        $('.stripes li:nth-child(94)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 23, 15); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 23, 15) });
        $('.stripes li:nth-child(95)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 23, 30); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 23, 30) });
        $('.stripes li:nth-child(96)').hover(function () { hoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 23, 45); }, function () { unhoverCurrentHour($(this).closest('div[data-storage-id]').attr('data-storage-id'), 23, 45) });
    }

    function getDateString(date) {
        // yyyy-MM-dd
        var dateStr =
            date.getFullYear() + "-" +
            ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
            ("00" + date.getDate()).slice(-2);
            return dateStr;
    }

    /**
    * refresh occupancy hours
    * @param {number} groupId
    * @param {string} selectedDate
    */
    function refreshOccupancy(groupId, selectedDates) {
        if (selectedDates.length > 0) {

            var dateObjectSelectedDate = [];
            for (let i = 0; i < selectedDates.length; i++)
            {
                dateObjectSelectedDate.push(getDateString(new Date(selectedDates[i])));
            }

            var actionUrl = "Occupancy/GetOccupancy";
            $.ajax({
                type: "POST",
                // async: false, // May be necessary when EF error for already used context
                url: appsettings.getUrl(actionUrl),
                data: { groupId: groupId, selectedDates: dateObjectSelectedDate },
                success: function (data) {
                    refreshNoOccupancySummary(data.NoOccupancySummary);
                    refreshTotalsOccupancy(data.TotalsOccupancy);
                    refreshDetailsOccupancy(data.DetailsOccupancy);
                    refreshAvailablePeople(data.AvailablePeople);
                    refreshOccupancyHours(data.OccupancyHours);
                                        
                    addHoverFunctions();
                                        
                    let year = ('' + selectedDates[0].getFullYear()).slice(2);
                    let month = ('0' + (selectedDates[0].getMonth() + 1)).slice(-2);
                    let day = ('0' + selectedDates[0].getDate()).slice(-2);                   

                    const d = new Date();
                    let hour = d.getHours();
                    let minute = (d.getMinutes() - (d.getMinutes() % 15)).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });

                    var date = year + month + day;
                    hoverCurrentHour(date, hour, minute);
                }
            });
        }
    }

    /**
    * Hover event current hour
    * @param {number} hour
    * @param {number} minute
    */
    function hoverCurrentHour(day, hour, minute) {
        $('.available-people').each(function () {
            var id = this.getAttribute('data-id');
            var textContent = availablePeople[id]['Q' + day + hour + zeroPad(minute, 2)];

            var headerCounter = $('.countertableHeader[data-id=' + id + '], .countertableHeader-red[data-id=' + id + ']')[0];
            headerCounter.textContent = String(textContent) + headerCounter.textContent.slice(headerCounter.textContent.indexOf('/'));

            //<span class="available-people" data-id="1">1</span>
            var counters = $('.available-people[data-id=' + id + ']');
            for (let i = 0; i < counters.length; i++) {
                var dividedCounter = counters[i].textContent.split('/');
                if (dividedCounter.length == 2) {
                    counters[i].textContent = String(textContent) + '/' + dividedCounter[1];
                }
            }

            if (occupancyHours[id]['Q' + day + hour + zeroPad(minute, 2)]) {
                addClass(this.parentNode, 'counter-red');
                addClass(headerCounter, 'countertableHeader-red');
            } else {
                removeClass(this.parentNode, 'counter-red');
                removeClass(headerCounter, 'countertableHeader-red');
                addClass(this.parentNode, 'counter');
                addClass(headerCounter, 'countertableHeader');
            }
        });

        $('[data-storage-id=' + day + '] .stripes li:nth-child(' + (1 + (hour * 4) + (minute / 15)) + ')').css('background', 'rgba(200, 225, 239, 0.8)');//'#c8e1ef' light blue
    }

    /**
    * UnhoverCurrentHour
    * @param {number} hour
    * @param {number} minute
    */
    function unhoverCurrentHour(day, hour, minute) {
        $('[data-storage-id=' + day + '] .stripes li:nth-child(' + (1 + (hour * 4) + (minute / 15)) + ')').css('background', 'rgba(225, 228, 232, 0.4)');//'#e1e4e8' light grey

        $('[data-storage-id=' + day + '] .available-people').each(function () {
            var id = this.getAttribute('data-id');

            if (occupancyHours[id]['Q' + day + hour + zeroPad(minute, 2)]) {
                $('[data-storage-id=' + day + '] #staffing-grid' + id + ' .stripes li:nth-child(' + (1 + (hour * 4) + (minute / 15)) + ')').css('background', 'rgba(232, 212, 213, 0.4)');//'#e8d4d5' light pink
            }
        });
    }


    /**
    * Check if the DOM element object has a certain class object
    * @param {Object} num
    * @param {Object} places
    */
    function zeroPad(num, places) {
        var zero = places - num.toString().length + 1;
        return Array(+(zero > 0 && zero)).join('0') + num;
    }

    /**
    * Check if the DOM element object has a certain class object
    * @param {Object} obj
    * @param {Object} cname
    */
    function hasClass(obj, cname) {
        return (obj.className ? obj.className.match(new RegExp('(\\s|^)' + cname + '(\\s|$)')) : false);
    }

    /**
    * Add a certain class from a DOM element
    * @param {Object} obj
    * @param {Object} cname
    */
    function addClass(obj, cname) {
        if (obj && !hasClass(obj, cname)) {
            obj.className += ' ' + cname;
        }
    }

    /**
    * Remove a certain class from a DOM element
    * @param {Object} obj
    * @param {Object} cname
    */
    function removeClass(obj, cname) {
        if (obj && hasClass(obj, cname)) {
            obj.className = obj.className.replace(new RegExp('(\\s|^)' + cname + '(?=\\s|$)'), '');
        }
    }

    return {
        /**
        * Init (binding button actions)
        */
        initialize: function () {
            this.occupancyHours = {};
            this.availablePeople = {};

            var calendarSelectedDate = $("#CSelectedDate").data("kendoCalendar");
            var selectedDates = calendarSelectedDate.selectDates();

            var ddlGroup = $("#DDLGroup");
            var groupId = ddlGroup.val();

            if (selectedDates != null && groupId != null) {
                loadVehicles(groupId);
                refreshOccupancy(groupId, selectedDates);
            }
        },

        /**
        * Toggle Function
        * @param {Object} e
        */
        toggleFunction: function (e) {
            var functionId = e.parentNode.getAttribute('data-function-id');
            $('[data-function-id=' + functionId + ']').each(function () {
                if (hasClass(this, 'collapsed')) {
                    removeClass(this, 'collapsed');
                } else {
                    addClass(this, 'collapsed');
                }
            })
        },


        /**
        * Load summary occupancy for the current selected group and date
        * @param {number} groupId
        * @param {string} selectedDate
        */
        loadNoOccupancySummary: function (groupId, selectedDate) {
            var data = { groupId: groupId, selectedDate: selectedDate };
            communication.syncJSON("GET", appsettings.getUrl("Occupancy/GetNoOccupancySummary"), data, function (responseData) {
                refreshNoOccupancySummary(responseData);
            });
        },



        /**
        * Load the totals of occupancy
        * @param {number} groupId
        * @param {string} selectedDate
        */
        loadTotalsOccupancy: function (groupId, selectedDate) {
            var data = { groupId: groupId, selectedDate: selectedDate };
            communication.syncJSON("GET", appsettings.getUrl("Occupancy/GetTotalsOccupancy"), data, function (responseData) {
                refreshTotalsOccupancy(responseData);
            });
        },


        /**
        * Load detail occupancy
        * @param {number} groupId
        * @param {string} selectedDate
        */
        loadDetailsOccupancy: function (groupId, selectedDate) {
            var data = { groupId: groupId, selectedDate: selectedDate };
            communication.syncJSON("GET", appsettings.getUrl("Occupancy/GetDetailsOccupancy"), data, function (responseData) {
                refreshDetailsOccupancy(responseData);
            });
        },




        /**
        * Date changed, refresh occupancy overview
        * @param {Object} e
        */
        CSelectedDate_OnChange: function (e) {
            var ddlGroup = $("#DDLGroup");
            var groupId = ddlGroup.val();
            if (groupId != undefined && groupId != null) {
                refreshOccupancy(groupId, this.selectDates());
            }
        },

        DatePeriod_Clicked: function (days) {
            var ddlGroup = $("#DDLGroup");
            var groupId = ddlGroup.val();
            if (groupId != undefined && groupId != null) {
                var datePeriod = [];

                var date = new Date().setHours(0, 0, 0, 0);
                var today = new Date(date);                

                for (let i = 0; i < days; i++) {
                    var dateTemp = new Date().setHours(0, 0, 0, 0);
                    var todayTemp = new Date(dateTemp);
                    datePeriod.push(new Date(todayTemp.setDate(today.getDate() + i)));
                }

                var calendarSelectedDate = $("#CSelectedDate").data("kendoCalendar");
                calendarSelectedDate.selectDates(datePeriod);

                refreshOccupancy(groupId, datePeriod);
            }
        },

        addDays: function (date, number) {
            const newDate = new Date(date);
            return new Date(newDate.setDate(date.getDate() + number));
        },

        /**
        * Group changed, refresh vehicles and occupancy overview
        * @param {Object} e
        */
        DDLGroup_OnChange: function (e) {
            loadVehicles(this.value());

            var calendarSelectedDate = $("#CSelectedDate").data("kendoCalendar");
            var selectedDates = calendarSelectedDate.selectDates();
            if (selectedDates != null) {
                refreshOccupancy(this.value(), selectedDates);
            }
        },

        /**
        * No Occupancy day clicked, refresh occupancy overview
        * @param {Object} e
        */
        LBNoOccupancyDay_OnClick: function (e) {
            var ddlGroup = $("#DDLGroup");
            var groupId = ddlGroup.val();

            var element = e.sender.select();
            var selectedDate = new Date(e.sender.dataItem(element[0]).DateOfDay);

            if (groupId != null && selectedDate != null) {
                var calendarSelectedDate = $("#CSelectedDate").data("kendoCalendar");
                calendarSelectedDate.selectDates(selectedDate);

                var data = { groupId: groupId, selectedDate: selectedDate.toDateString() };
                communication.syncJSON("GET", appsettings.getUrl("Occupancy/GetOccupancy"), data, function (responseData) {
                    refreshTotalsOccupancy(responseData.TotalsOccupancy);
                    refreshDetailsOccupancy(responseData.DetailsOccupancy);
                    addHoverFunctions();
                });               
            }
        },

        Information_Clicked: function (occupancyDateInfoText) {
            main.openActionsDialog(' ', occupancyDateInfoText, [{ text: 'Ok', action: function () { main.closePopup(); } }], 180);
        }
    }
}();